import { Component, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core'
import { InfiniteScroll } from 'ionic-angular'

import { PaginatedList } from '../'

@Component({
  selector: 'infinite-paginator',
  templateUrl: 'infinite-paginator.html'
})
export class InfinitePaginator implements OnChanges {
  @Input()
  list: PaginatedList<any>

  @Input()
  enabled: boolean = true

  @Input()
  position: string

  @ViewChild(InfiniteScroll) infiniteScroll: InfiniteScroll

  ngOnChanges(e: SimpleChanges) {
    if (e.list && e.list.currentValue) {
      // listの参照が変わったらリセットする
      this.enable(!e.list.currentValue.ended)
    }
  }

  doInfinite(e: InfiniteScroll) {
    if (!this.list) {
      return
    }

    this.list.loadNextPage().subscribe((loaded) => {
      e.complete()

      if (!loaded) {
        e.enable(false)
      }
    })
  }

  enable(v: boolean) {
    this.infiniteScroll.enable(v)
  }
}



// WEBPACK FOOTER //
// ./src/libs/infinite-paginator/components/infinite-paginator.ts